// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class PositionCallsStatus implements flatbuffers.IUnpackableObject<PositionCallsStatusT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PositionCallsStatus {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPositionCallsStatus(bb:flatbuffers.ByteBuffer, obj?:PositionCallsStatus):PositionCallsStatus {
  return (obj || new PositionCallsStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPositionCallsStatus(bb:flatbuffers.ByteBuffer, obj?:PositionCallsStatus):PositionCallsStatus {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PositionCallsStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

front(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : 0;
}

frontLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

frontArray():Int16Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? new Int16Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

rear(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : 0;
}

rearLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

rearArray():Int16Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? new Int16Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

frontLock(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : 0;
}

frontLockLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

frontLockArray():Int16Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? new Int16Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

rearLock(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : 0;
}

rearLockLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

rearLockArray():Int16Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? new Int16Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

static startPositionCallsStatus(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addFront(builder:flatbuffers.Builder, frontOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, frontOffset, 0);
}

static createFrontVector(builder:flatbuffers.Builder, data:number[]|Int16Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createFrontVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createFrontVector(builder:flatbuffers.Builder, data:number[]|Int16Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(2, data.length, 2);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]!);
  }
  return builder.endVector();
}

static startFrontVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(2, numElems, 2);
}

static addRear(builder:flatbuffers.Builder, rearOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, rearOffset, 0);
}

static createRearVector(builder:flatbuffers.Builder, data:number[]|Int16Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createRearVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createRearVector(builder:flatbuffers.Builder, data:number[]|Int16Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(2, data.length, 2);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]!);
  }
  return builder.endVector();
}

static startRearVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(2, numElems, 2);
}

static addFrontLock(builder:flatbuffers.Builder, frontLockOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, frontLockOffset, 0);
}

static createFrontLockVector(builder:flatbuffers.Builder, data:number[]|Int16Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createFrontLockVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createFrontLockVector(builder:flatbuffers.Builder, data:number[]|Int16Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(2, data.length, 2);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]!);
  }
  return builder.endVector();
}

static startFrontLockVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(2, numElems, 2);
}

static addRearLock(builder:flatbuffers.Builder, rearLockOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, rearLockOffset, 0);
}

static createRearLockVector(builder:flatbuffers.Builder, data:number[]|Int16Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createRearLockVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createRearLockVector(builder:flatbuffers.Builder, data:number[]|Int16Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(2, data.length, 2);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]!);
  }
  return builder.endVector();
}

static startRearLockVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(2, numElems, 2);
}

static endPositionCallsStatus(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // front
  builder.requiredField(offset, 6) // rear
  builder.requiredField(offset, 8) // front_lock
  builder.requiredField(offset, 10) // rear_lock
  return offset;
}

static createPositionCallsStatus(builder:flatbuffers.Builder, frontOffset:flatbuffers.Offset, rearOffset:flatbuffers.Offset, frontLockOffset:flatbuffers.Offset, rearLockOffset:flatbuffers.Offset):flatbuffers.Offset {
  PositionCallsStatus.startPositionCallsStatus(builder);
  PositionCallsStatus.addFront(builder, frontOffset);
  PositionCallsStatus.addRear(builder, rearOffset);
  PositionCallsStatus.addFrontLock(builder, frontLockOffset);
  PositionCallsStatus.addRearLock(builder, rearLockOffset);
  return PositionCallsStatus.endPositionCallsStatus(builder);
}

unpack(): PositionCallsStatusT {
  return new PositionCallsStatusT(
    this.bb!.createScalarList<number>(this.front.bind(this), this.frontLength()),
    this.bb!.createScalarList<number>(this.rear.bind(this), this.rearLength()),
    this.bb!.createScalarList<number>(this.frontLock.bind(this), this.frontLockLength()),
    this.bb!.createScalarList<number>(this.rearLock.bind(this), this.rearLockLength())
  );
}


unpackTo(_o: PositionCallsStatusT): void {
  _o.front = this.bb!.createScalarList<number>(this.front.bind(this), this.frontLength());
  _o.rear = this.bb!.createScalarList<number>(this.rear.bind(this), this.rearLength());
  _o.frontLock = this.bb!.createScalarList<number>(this.frontLock.bind(this), this.frontLockLength());
  _o.rearLock = this.bb!.createScalarList<number>(this.rearLock.bind(this), this.rearLockLength());
}
}

export class PositionCallsStatusT implements flatbuffers.IGeneratedObject {
constructor(
  public front: (number)[] = [],
  public rear: (number)[] = [],
  public frontLock: (number)[] = [],
  public rearLock: (number)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const front = PositionCallsStatus.createFrontVector(builder, this.front);
  const rear = PositionCallsStatus.createRearVector(builder, this.rear);
  const frontLock = PositionCallsStatus.createFrontLockVector(builder, this.frontLock);
  const rearLock = PositionCallsStatus.createRearLockVector(builder, this.rearLock);

  return PositionCallsStatus.createPositionCallsStatus(builder,
    front,
    rear,
    frontLock,
    rearLock
  );
}
}
